// Mock data for École des Maîtres Dauphins - Cursus Thérapeutes
// All content is mocked for the frontend-only landing page clone.

export const IMG = {
  heroDolphin:
    "https://gillesdelieuze.com/wp-content/uploads/2025/03/gilles1385_dolphins_joy_happiness_neon_stellar_furist_ultra_det_d108e6d0-77b9-454e-9100-27fcbd17df2c-650x650.png",
  dolphinsWide:
    "https://gillesdelieuze.com/wp-content/uploads/2024/08/gilles1385_dolphins_galactica_bright_colors_joy_turquoise_photo_fd93484f-89cd-4eac-b620-a1845d635b21-1024x650.png",
  meditation:
    "https://gillesdelieuze.com/wp-content/uploads/2024/08/gilles1385_12_humains_qui_medites_avec_des_dauphins_de_cristal__21acedb8-2c3b-425f-80ee-927aebe800ab-650x650.png",
  bodyChakras:
    "https://gillesdelieuze.com/wp-content/uploads/2025/02/gilles1385_figurative_futurist_photo_human_body_with_chakras_li_69b129c5-85d1-4185-bf5f-dbe1d90470b0.png",
  sevenChakra:
    "https://gillesdelieuze.com/wp-content/uploads/2025/02/gilles1385_a_spiritual_meditator_showing_the_7_chakra_on_their__956d38f6-b85a-4127-ab77-f1e0e6ca843d.png",
  mirrorLight:
    "https://gillesdelieuze.com/wp-content/uploads/2024/09/DALL%C2%B7E-2024-09-01-16.45.56-An-ethereal-and-spiritual-illustration-representing-the-Mirror-of-Light-healing-protocol.-A-semi-transparent-human-silhouette-stands-at-the-center-.webp",
  gilles:
    "https://gillesdelieuze.com/wp-content/uploads/2022/10/Gilles-2a-650x650.jpg",
  soin:
    "https://gillesdelieuze.com/wp-content/uploads/2024/11/gilles1385_soin_energetique_initiation_avec_les_dauphins_multid_dbedaed2-4935-4298-9aa6-7f5d969c568c-650x650.png",
};

export const RESERVE_URL =
  "https://gillesdelieuze.com/bdc-ecole-maitres-dauphins/";

export const setupPoints = [
  "ton \u00e9tat int\u00e9rieur",
  "ta contenance",
  "la puret\u00e9 de ta guidance (sans filtres, sans projections)",
  "ta capacit\u00e9 \u00e0 accompagner quelqu'un dans toutes ses dimensions",
];

export const shift = {
  left: {
    title: "Raisonnement",
    subtitle: "La plupart des accompagnements fonctionnent encore ici",
    items: ["comprendre", "analyser", "expliquer", "convaincre", "\u00ab faire faire \u00bb"],
  },
  right: {
    title: "R\u00e9sonance",
    subtitle: "Ici, tu passes dans une autre dimension",
    items: [
      "ton \u00e9tat devient le vecteur",
      "ta coh\u00e9rence devient le soin",
      "ta pr\u00e9sence devient l'architecture",
    ],
  },
};

export const developCards = [
  {
    n: "01",
    title: "D\u00e9projection & guidance plus pure",
    points: [
      "rep\u00e9rer tes filtres (sauveur discret, besoin de r\u00e9ussir)",
      "nettoyer la projection",
      "recevoir une guidance plus fine, plus sobre, plus juste",
      "rester en lien sans te fatiguer",
    ],
  },
  {
    n: "02",
    title: "Contenance & r\u00e9ception",
    points: [
      "plus de contenance = clients plus en s\u00e9curit\u00e9",
      "plus de r\u00e9ception = ajustements plus pr\u00e9cis",
      "plus de stabilit\u00e9 = tu r\u00e9cup\u00e8res plus vite",
      "plus de coh\u00e9rence = transformations qui se stabilisent",
    ],
  },
  {
    n: "03",
    title: "Protocoles simples & puissants",
    points: [
      "en individuel / en collectif",
      "en pr\u00e9sentiel / \u00e0 distance",
      "sur humains, animaux, lieux, v\u00e9g\u00e9taux",
      "harmonisation, r\u00e9alignement, int\u00e9gration",
    ],
  },
  {
    n: "04",
    title: "Expansion naturelle",
    points: [
      "tu accompagnes plus juste",
      "tu accompagnes plus de monde sans t'\u00e9puiser",
      "ton rayonnement devient magn\u00e9tique",
      "la fluidit\u00e9 arrive par congruence",
    ],
  },
];

export const receiveItems = [
  { count: "14", label: "transmissions", desc: "paradigme + posture + multi-conscience" },
  { count: "14", label: "m\u00e9ditations", desc: "centrage / clart\u00e9 / coh\u00e9rence" },
  { count: "14", label: "int\u00e9grations", desc: "stabilisation, contenance, ancrage" },
  { count: "\u221e", label: "protocoles", desc: "individuel & collectif, pr\u00e9sentiel & distance" },
];

export const programItems = [
  {
    title: "Sessions mensuelles sur Zoom",
    desc: "Chaque mois, on explore un th\u00e8me pr\u00e9cis, on identifie les blocages et tu repars avec des outils pratiques.",
    icon: "Video",
  },
  {
    title: "Ressources exclusives en ligne",
    desc: "M\u00e9ditations guid\u00e9es, exercices pratiques et enseignements pour int\u00e9grer au quotidien.",
    icon: "BookOpen",
  },
  {
    title: "Communaut\u00e9 bienveillante",
    desc: "Un groupe en ligne pour partager, poser tes questions et recevoir le soutien des autres membres.",
    icon: "Users",
  },
  {
    title: "Acc\u00e8s direct \u00e0 Gilles",
    desc: "Lors des sessions de groupe et par messages priv\u00e9s. Un accompagnement sur mesure.",
    icon: "MessageCircle",
  },
  {
    title: "Soins quantiques",
    desc: "Initiation \u00e0 16 fr\u00e9quences delphiques et comment les utiliser pour des soins \u00e9nerg\u00e9tiques puissants.",
    icon: "Sparkles",
  },
];

export const quantumLevels = [
  {
    title: "Dans ton corps",
    desc: "pour lib\u00e9rer les m\u00e9moires souffrantes engramm\u00e9es.",
    img: IMG.bodyChakras,
  },
  {
    title: "Dans ton champ \u00e9nerg\u00e9tique",
    desc: "pour harmoniser tous tes corps subtils et retrouver ton alignement.",
    img: IMG.sevenChakra,
  },
  {
    title: "Ta conscience sup\u00e9rieure",
    desc: "en te connectant \u00e0 ta dimension divine, cet \u00e9tat de pure potentialit\u00e9.",
    img: IMG.mirrorLight,
  },
];

export const testimonials = [
  { name: "Julie", role: "\u00e9nerg\u00e9ticienne \u00b7 6 ans", before: "Je sortais des s\u00e9ances lessiv\u00e9e, je portais.", after: "Je tiens l'espace sans m'y perdre. Mon \u00e9tat reste stable." },
  { name: "Marc", role: "coach entrepreneurs", before: "D\u00e9clics en s\u00e9ance, retomb\u00e9e ensuite.", after: "Int\u00e9gration plus stable. Les changements tiennent." },
  { name: "Sabrina", role: "th\u00e9rapeute psycho-corporelle", before: "Je cherchais la technique parfaite.", after: "\u00c9tat + contenance + int\u00e9gration. Tout s'est simplifi\u00e9." },
  { name: "Yannis", role: "praticien \u00e0 distance", before: "\u00c0 distance, r\u00e9sultats variables.", after: "Protocole clair + coh\u00e9rence : reproductible." },
  { name: "Claire", role: "praticienne \u00e9thique", before: "Monter en gamme sans d\u00e9river.", after: "Posture plus propre, guidance plus fine." },
  { name: "Olivier", role: "th\u00e9rapeute holistique", before: "Guidance parasit\u00e9e par mon mental.", after: "Moins de projections. Plus de justesse." },
  { name: "Ana\u00efs", role: "facilitatrice de groupes", before: "En collectif, je perdais en finesse.", after: "Je per\u00e7ois le champ collectif et j'ajuste." },
  { name: "L\u00e9a", role: "accompagnante \u00b7 8 ans", before: "Je pensais devoir 'faire' plus.", after: "J'entretiens ma coh\u00e9rence, mes accompagn\u00e9s s'alignent." },
];

export const pricing = [
  {
    name: "Formule Classique",
    subtitle: "\u00c9cole des Ma\u00eetres Dauphins",
    oldPrice: "2222\u20ac",
    price: "1555,40\u20ac",
    note: "Paiement x1, x2, x3, x5, x10 ou x12",
    popular: false,
    features: [
      "Formation compl\u00e8te avec acc\u00e8s illimit\u00e9",
      "Modules de soins \u00e9nerg\u00e9tiques",
      "5 fr\u00e9quences bonus (Baleine, B\u00e9luga, M\u00e9duse, Hippocampe, Raie)",
      "Live Mensuel",
      "Masterclass invit\u00e9s sp\u00e9ciaux",
      "Acc\u00e8s communaut\u00e9 active",
    ],
  },
  {
    name: "Formule VIP",
    subtitle: "\u00c9cole + Mentorat 1to1",
    oldPrice: "3333\u20ac",
    price: "2333,10\u20ac",
    note: "Paiement x1, x2, x3",
    popular: true,
    features: [
      "Tout de la formule Classique",
      "Fil d'urgence prioritaire",
      "Mentorat & supervision 1to1",
      "3 RDV d'1h30 avec Gilles",
    ],
  },
];

export const bonuses = [
  { tag: "Bonus #1", value: "149\u20ac", title: "Protocole chamanique des deuils et renaissances", desc: "Lib\u00e8re l'ancien pour accueillir le nouveau gr\u00e2ce \u00e0 ce puissant protocole." },
  { tag: "Bonus #2", value: "231\u20ac", title: "3 transmissions \u00b7 Baleine, B\u00e9luga, Raie", desc: "Acc\u00e8de \u00e0 des savoirs galactiques et comprends ta place dans le monde." },
  { tag: "Bonus #3", value: "180\u20ac", title: "Sommet M\u00e9tamorphose \u00b7 oser prendre TA PLACE", desc: "5 cl\u00e9s pour suivre ta voix et 7 p\u00e9pites pour lancer une activit\u00e9 align\u00e9e." },
];

export const comparison = [
  { title: "D\u00e9veloppement personnel", text: "Tu ajoutes des couches pour 'devenir meilleur'. Il y a toujours quelque chose \u00e0 am\u00e9liorer, tu n'es jamais arriv\u00e9. Ici, la d\u00e9marche est inverse : tu te d\u00e9pouilles pour retrouver ta nature profonde." },
  { title: "Hypnose", text: "Tu agis seulement sur ton subconscient. Avec les fr\u00e9quences delphiques, tu agis \u00e0 tous les niveaux : m\u00e9moires, corps physique, \u00e9motionnel et spirituel." },
  { title: "M\u00e9ditation", text: "Elle permet un \u00e9tat modifi\u00e9 mais pas l'expansion des ondes c\u00e9r\u00e9brales. Les fr\u00e9quences quantiques te font plonger dans des espaces multidimensionnels." },
];

export const faqs = [
  { q: "Je suis d\u00e9j\u00e0 form\u00e9(e) partout.", a: "Justement. Ici, tu ne rajoutes pas : tu affûtes. Posture, \u00e9tat, multi-conscience, coh\u00e9rence : le niveau au-dessus des outils." },
  { q: "J'ai peur de d\u00e9river.", a: "Ici, c'est cadr\u00e9 : autonomie du client, non-d\u00e9pendance, posture propre, supervision en live." },
  { q: "Je suis fatigu\u00e9(e), pas envie d'un truc lourd.", a: "C'est l'inverse : \u00e7a te rend plus l\u00e9ger(\u00e8re). Moins d'absorption. Plus de contenance. Plus de r\u00e9cup\u00e9ration." },
  { q: "Et si ce n'est pas pour moi ?", a: "Alors tu le sauras vite : c'est une \u00c9cole premium. Soit tu sens l'appel du high level, soit tu attends encore un cycle." },
  { q: "Je veux du concret, pas des grands mots.", a: "Tu repars avec des protocoles simples, utilisables en pr\u00e9sentiel, \u00e0 distance, en individuel et en collectif. Et surtout : une structure d'int\u00e9gration." },
  { q: "Quelle est la garantie ?", a: "Tu as 14 jours pour tester le module 1. Si cela ne te correspond pas, tu es rembours\u00e9(e) int\u00e9gralement en 48h." },
];

export const navLinks = [
  { label: "Le Shift", href: "#shift" },
  { label: "Le Programme", href: "#programme" },
  { label: "T\u00e9moignages", href: "#temoignages" },
  { label: "Tarifs", href: "#tarifs" },
  { label: "Gilles", href: "#gilles" },
  { label: "FAQ", href: "#faq" },
];
